import { styled } from 'styled-components';

import Paper from 'components/Paper/Paper';
import SEO from 'components/SEO';
import FormRow from 'components/FormRow';
import ToggleCheckbox from 'components/ui/ToggleCheckbox';
import useTheme from 'hooks/useTheme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 400px;
`;

const Preference = () => {
  const { themeType, onToggleTheme } = useTheme();
  return (
    <>
      <SEO title="환경설정" />
      <Paper title="환경설정">
        <Container>
          <FormRow label="다크모드" direction="row">
            <ToggleCheckbox id="theme" checked={themeType === 'dark'} onChange={onToggleTheme} />
          </FormRow>
        </Container>
      </Paper>
    </>
  );
};

export default Preference;
